/** Local calendar date (YYYY-MM-DD) for an instant in an IANA timezone. */
export function localDateIn(timeZone: string, at: Date = new Date()): string {
  const parts = new Intl.DateTimeFormat('en-CA', { timeZone, year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(at);
  const get = (t: string) => parts.find((p) => p.type === t)?.value ?? '';
  return `${get('year')}-${get('month')}-${get('day')}`;
}

export function shiftDate(day: string, days: number): string {
  const d = new Date(`${day}T12:00:00Z`);
  d.setUTCDate(d.getUTCDate() + days);
  return d.toISOString().slice(0, 10);
}

/** Short human timezone label, e.g. "America/Mexico_City (GMT-6)". */
export function timeZoneLabel(timeZone: string, at: Date = new Date()): string {
  try {
    const off = new Intl.DateTimeFormat('es-MX', { timeZone, timeZoneName: 'shortOffset' })
      .formatToParts(at)
      .find((p) => p.type === 'timeZoneName')?.value;
    return off ? `${timeZone.replace(/_/g, ' ')} (${off})` : timeZone;
  } catch {
    return timeZone;
  }
}
